<template>
	<div class="padbox">
		<!-- <div style="display: flex;" v-if="hasAuth('ROLE_admin')">
			<div>
				<div class="calssd"><span style="font-size: 18px;font-weight: bold;color: #000;">退货收货地址 :</span> <span
						style="font-size: 18px;color: #666;">{{ names.address }}</span></div>
				<div class="calssd"><span style="font-size: 18px;font-weight: bold;color: #000;">退货收货人 :</span> <span
						style="font-size: 18px;color: #666;">{{ names.name }}</span></div>
				<div class="calssd"><span style="font-size: 18px;font-weight: bold;color: #000;">退货收货手机号 :</span> <span
						style="font-size: 18px;color: #666;">{{ names.phone }}</span></div>
			</div>
			<el-button class="btnimgs" @click="unit(names)" type="success">编辑</el-button>
		</div>
		<el-dialog title="订单详情" :visible.sync="smvisible" width="1000px" append-to-body :close-on-click-modal="false"
			class="dialogClass">
			<el-form label-width="100px" class="demo-editForm">
				<el-form-item label="默认地址" prop="adress" label-width="100px">
					<el-input v-model="adress" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="name" label-width="100px">
					<el-input v-model="name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone" label-width="100px">
					<el-input v-model="phone" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="submitForm()">
				保存
			</el-button>
		</el-dialog> -->
	</div>
</template>
<script>
import SideMenu from "./inc/SideMenu";
export default {
	name: "Index",
	components: {
		SideMenu
	},
	data() {
		return {
			names: '',
			adress: '',
			phone: '',
			name: '',
			smvisible: false
		}
	},
	created() {
		this.ushows()
	},
	methods: {
		// ushows() {
		// 	this.$axios
		// 		.post('/admin/defaultAddress/getDetail')
		// 		.then((res) => {
		// 			this.names = res.data

		// 		})
		// },
		// unit(e) {
		// 	this.adress = e.address
		// 	this.phone = e.phone
		// 	this.name = e.name
		// 	this.smvisible = true
		// },
		// submitForm() {

		// 	this.$axios
		// 		.post('/admin/defaultAddress/update', {
		// 			address: this.adress,
		// 			phone: this.phone,
		// 			name: this.name,
		// 			id: 1
		// 		})
		// 		.then((res) => {
		// 			this.smvisible = false
		// 			this.ushows()
		// 		})
		// }

	}
}
</script>


<style scoped>
.padbox {
	padding: 20px;
	box-sizing: border-box;
}

.flexjcen {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flexcen {
	display: flex;
	align-items: center;
}

.echarn {
	width: 22%;
	background: #fff;
	padding: 30px;
	box-sizing: border-box;
	border-radius: 10px;
}

.cnum {
	font-size: 20px;
	margin-top: 10px;
	margin-bottom: 20px;
}

.titles {
	font-size: 15px;
	color: #999;
}

.lines {
	width: 100%;
	height: 1px;
	background: #ccc;
	margin: 20px 0px 10px;
}

.cardbox {
	width: 100%;
	background: #ffffff;
	border-radius: 10px;
	padding: 30px;
	box-sizing: border-box;
	height: 600px;
	display: flex;
}

.leftab {
	width: 60%;
	position: relative;
}

.rank {
	font-weight: bold;
	font-size: 18px;
}

.ranbox {
	padding-left: 60px;
	box-sizing: border-box;
	width: 40%;
}

.criles {
	background: rgb(49, 70, 89);
	width: 26px;
	height: 26px;
	border-radius: 50%;
	line-height: 26px;
	text-align: center;
	color: #fff;
	margin-right: 10px;
}

.hcrile {
	background: rgb(240, 242, 245);
	width: 26px;
	height: 26px;
	border-radius: 50%;
	line-height: 26px;
	text-align: center;
	color: #666;
	margin-right: 10px;
}

.cbox {
	position: absolute;
	right: 10px;
	top: 10px;
	width: 300px;
	height: 30px;
}

.btnimgs {
	margin-left: 40px;
	display: block;
	height: 40px;
}

.calssd {
	height: 40px;
	line-height: 40px;
}
</style>